import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import KaakaziniAdminApp from "./kaakazini-admin/api/KaakaziniAdminApp";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ShopPage from "./pages/shop/ShopPage";
import ProductDetailPage from "./pages/shop/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/shop/CheckoutPage";

const root = ReactDOM.createRoot(document.getElementById("root"));

const isAdminPath =
  window.location.pathname.startsWith("/admin-login") ||
  window.location.pathname.startsWith("/admin-dashboard");

const isShopBuild = process.env.REACT_APP_BUILD_TARGET === "shop";

root.render(
  <React.StrictMode>
    {isShopBuild ? (
      <CartProvider>
        <BrowserRouter>
          <Routes>
            {/* SHOP HOME */}
            <Route
              path="/"
              element={<ShopPage />}
            />

            {/* PRODUCT DETAILS */}
            <Route
              path="/product/:id"
              element={<ProductDetailPage />}
            />

            {/* CART */}
            <Route
              path="/cart"
              element={<CartPage />}
            />

            {/* CHECKOUT */}
            <Route
              path="/checkout"
              element={<CheckoutPage />}
            />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    ) : isAdminPath ? (
      <KaakaziniAdminApp />
    ) : (
      <AuthProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </AuthProvider>
    )}
  </React.StrictMode>
);

reportWebVitals();